<div class="left-side-container">
  <div class="logo">
    <img src="/assets/images/logo-text-medium.svg" alt="bold penguin logo" />
  </div>
  <h1 class="mat-headline-large">{{ messageDisplay.title }}</h1>
  <h2 class="mat-title-medium">{{ messageDisplay.subheader }}</h2>

  <div class="bullet" *ngFor="let bullet of messageDisplay.bullets">
    <emperor-icon name="check_in_circle"></emperor-icon>
    <p class="mat-body-large">{{ bullet.body }}</p>
  </div>
</div>
